/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Status_Export_FailedInputs */



/**
* | output |
* | --- |
* | "Export failed" |
*
* @param {Video_Export_Status_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_export_failed = /** @type {((inputs?: Video_Export_Status_Export_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_Export_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation echouee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione fallita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт не удался")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación fallida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात विफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação falhou")
	return /** @type {LocalizedString} */ ("Export failed")
});